/**
 * Cada cuánto se refresca cada pantalla. Puro.
 *
 * Refrescar tiene costo (el detalle de campaña agrega contadores sobre miles de mensajes): sólo se
 * refresca lo que puede cambiar solo. Una campaña terminada o una plantilla aprobada no cambian.
 */

import type { EstadoCampanaOficial, EstadoPlantilla } from "../types";

/** Intervalo del detalle de campaña: enviando 3000 ms; programada, pausada_auto 30000; el resto null (no se refresca). */
export function intervaloDetalle(estado: EstadoCampanaOficial | undefined): number | null {
  if (estado === "enviando") return 3000;
  if (estado === "programada" || estado === "pausada_auto") return 30000;
  return null;
}

/** Lista o detalle de plantillas: 30000 si alguna está en received/pending/unsubmitted; si no, null. */
export function intervaloPlantillas(estados: EstadoPlantilla[]): number | null {
  return (estados || []).some((e) => e === "received" || e === "pending" || e === "unsubmitted") ? 30000 : null;
}
